import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ModeloVeiculoService {
	private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getModelosVeiculo(ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/modelosveiculo' + (ordem? '/ordem/' + ordem : ''))
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getModeloVeiculo(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/modelosveiculo/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getModelosVeiculoByMarca(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/modelosveiculo/marca/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	criaModeloVeiculo(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/modelosveiculo', {
				modelo_veiculo_nome: data.modelo_veiculo_nome,
				marca_veiculo_id: data.marca_veiculo_id,
				status: '1'
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaModeloVeiculo(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/modelosveiculo/' + data.modelo_veiculo_id, {
				modelo_veiculo_nome: data.modelo_veiculo_nome,
				marca_veiculo_id: data.marca_veiculo_id,
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	apagaModeloVeiculo(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/modelosveiculo/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaModeloVeiculoStatus(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/modelosveiculo/' + data.modelo_veiculo_id, {
				status: data.status,
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

}
